import { z } from 'zod';

export const View3dDisplay = z.object({
  enabled: z.boolean(),
  viewVersion: z.string(),
  fullscreen: z.boolean(),
  copySeatLink: z.boolean(),
});
